import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
} from '@angular/core';
import {
    FormArray,
    FormBuilder,
    FormControl,
    FormGroup,
    Validators,
} from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { ActivatedRoute } from '@angular/router';
import { QuillModules } from 'ngx-quill';
import {
    ReplaySubject,
    Subject,
    debounceTime,
    distinctUntilChanged,
    takeUntil,
} from 'rxjs';
import {
    CATEGORY_TYPE,
    INPUT_TYPE,
    InputType,
    OptionInputTypes,
    PaginationLimit,
    RISK_TYPE,
    SMTP_STATUS,
    SearchEntity,
} from 'src/app/core/constants/dropdown-contants';
import { urlRoutes } from 'src/app/core/constants/url-route.constant';
import { filterValue, random4DigitId } from 'src/app/core/helpers/helperfunc';
import { AuthenticationService } from 'src/app/core/services/auth/authentication.service';

import { FormMasterService } from 'src/app/core/services/form-master/form-master.service';
import { LoaderService } from 'src/app/core/services/loader/loader.service';
import { NavigationService } from 'src/app/core/services/navigation/navigation.service';
import { ToasterService } from 'src/app/core/services/toaster/toaster.service';
import { UniversityService } from 'src/app/core/services/university/university.service';

@Component({
    selector: 'app-coventry-form',
    templateUrl: './coventry-form.component.html',
    styleUrls: ['./coventry-form.component.scss'],
})
export class CoventryFormComponent implements OnInit, OnDestroy {
    @Input() interviewForm: FormGroup | any;
    @Input() showOnlyTemplate: boolean = false;
    @Input() questions: any = null;
    @Output() formSubmit: EventEmitter<any> = new EventEmitter<any>();

    option_form: FormGroup;
    statuses = SMTP_STATUS;
    inputtype = INPUT_TYPE;
    risk = RISK_TYPE;
    category = CATEGORY_TYPE;
    input_type_list = InputType;
    option_id: string;
    key_value_columns = ['Option Value Name', 'Sort Order', 'Country', ''];
    is_option_values_valid: boolean = false;
    is_submitted: boolean = false;
    options_values: any;

    private _unsubscribeAll: Subject<any> = new Subject();
    uni_countries_name: any;
    university_countries_lists: any;
    public uniCountriesFilterCtrl: FormControl<string> =
        new FormControl<string>('');
    public filteredUniCountries: ReplaySubject<any> = new ReplaySubject<any>(1);
    filterValue = filterValue;
    option_input_types = OptionInputTypes;

    university: any;
    university_name: any[] = [];
    public university_filter: FormControl<string> = new FormControl<string>('');
    public filtered_university: ReplaySubject<any> = new ReplaySubject<any>(1);
    university_pagination = {
        skip: 0,
        limit: PaginationLimit.university,
    };
    total_university_count: number = 0;
    university_offset: number = 0;
    university_id: any;
    filter_entity: any;
    search_university: string = '';
    search_entiry = SearchEntity;

    QuillModules: QuillModules = {
        toolbar: [
            // default value
            ['bold', 'italic', 'underline', 'strike'], // toggled buttons
            // ['blockquote', 'code-block'],
            // [{ header: 1 }, { header: 2 }], // custom button values
            [{ list: 'ordered' }, { list: 'bullet' }],
            // [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
            // [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
            // [{ direction: 'rtl' }], // text direction
            // [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
            // [{ header: [1, 2, 3, 4, 5, 6, false] }],
            // [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            // [{ font: [] }],
            // [{ align: [] }],
            // ['clean'], // remove formatting button
            // ['link', 'image', 'video'], // link and image, video
        ],
    };

    radioQuestionArr: any = [
        {
            type: 'radio',
            labelName: 'Common Questions',
            categoryName: 'Common',
            isRequired: true,
            question: 'Am I speaking to the same person as shown in the passport?',
            options: [
                {
                    id: 'passport_check1',
                    name: 'passport_check',
                    value: 'Answered',
                    label: 'Yes',
                },
                {
                    id: 'passport_check2',
                    name: 'passport_check',
                    value: 'Not Answered',
                    label: 'No',
                },
                {
                    id: 'passport_check3',
                    name: 'passport_check',
                    value: 'Doubtful',
                    label: 'Doubtful',
                },
               
            ],
            subQuestions: [
                {
                    labelName: 'Doubtful Questions',
                    categoryName: 'Doubtful',
                    id: 'Doubtful',
                    type: 'radio',
                    isRequired: true,
                    question: 'Please confirm your Date of Birth',
                    options: [
                        {
                            id: 'doubt_dob1',
                            name: 'doubt_dob',
                            value: 'Answered',
                            label: 'Answered',
                        },
                        {
                            id: 'doubt_dob2',
                            name: 'doubt_dob',
                            value: 'Not Answered',
                            label: 'Not Answered',
                        },
                    ],
                },
                {
                    labelName: 'Doubtful Questions',
                    categoryName: 'Doubtful',
                    id: 'Doubtful',
                    type: 'radio',
                    isRequired: true,
                    question: 'Please tell me your place of birth',
                    options: [
                        {
                            id: 'doubt_dobplace1',
                            name: 'doubt_dobplace',
                            value: 'Answered',
                            label: 'Answered',
                        },
                        {
                            id: 'doubt_dobplace2',
                            name: 'doubt_dobplace',
                            value: 'Not Answered',
                            label: 'Not Answered',
                        },
                    ],
                },
                {
                    labelName: 'Doubtful Questions',
                    categoryName: 'Doubtful',
                    id: 'Doubtful',
                    type: 'radio',
                    isRequired: true,
                    question: 'From which school have you studied',
                    options: [
                        {
                            id: 'doubt_school1',
                            name: 'doubt_dobplace',
                            value: 'Answered',
                            label: 'Answered',
                        },
                        {
                            id: 'doubt_school2',
                            name: 'doubt_dobplace',
                            value: 'Not Answered',
                            label: 'Not Answered',
                        },
                    ],
                },
                {
                    labelName: 'Doubtful Questions',
                    categoryName: 'Doubtful',
                    id: 'Doubtful',
                    type: 'radio',
                    isRequired: true,
                    question: 'What is your House address',
                    options: [
                        {
                            id: 'doubt_add1',
                            name: 'doubt_add',
                            value: 'Answered',
                            label: 'Answered',
                        },
                        {
                            id: 'doubt_add2',
                            name: 'doubt_add',
                            value: 'Not Answered',
                            label: 'Not Answered',
                        },
                    ],
                },
                {
                    labelName: 'Doubtful Questions',
                    categoryName: 'Doubtful',
                    id: 'Doubtful',
                    type: 'radio',
                    isRequired: true,
                    question:
                        'Please confirm me your Email id and phone number',
                    options: [
                        {
                            id: 'doubt_email1',
                            name: 'doubt_email',
                            value: 'Answered',
                            label: 'Answered',
                        },
                        {
                            id: 'doubt_email2',
                            name: 'doubt_email',
                            value: 'Not Answered',
                            label: 'Not Answered',
                        },
                    ],
                },
                {
                    labelName: 'Doubtful Questions',
                    categoryName: 'Doubtful',
                    id: 'Doubtful',
                    type: 'radio',
                    isRequired: true,
                    question: "What is your father's and mother's name",
                    options: [
                        {
                            id: 'doubt_mother1',
                            name: 'doubt_mother',
                            value: 'Answered',
                            label: 'Answered',
                        },
                        {
                            id: 'doubt_mother2',
                            name: 'doubt_mother',
                            value: 'Not Answered',
                            label: 'Not Answered',
                        },
                    ],
                },
                {
                    labelName: 'Doubtful Questions',
                    categoryName: 'Doubtful',
                    id: 'Doubtful',
                    type: 'radio',
                    isRequired: true,
                    question: 'Please confirm your parents their Date of Birth',
                    options: [
                        {
                            id: 'doubt_fdob1',
                            name: 'doubt_fdob',
                            value: 'Answered',
                            label: 'Answered',
                        },
                        {
                            id: 'doubt_fdob2',
                            name: 'doubt_fdob',
                            value: 'Not Answered',
                            label: 'Not Answered',
                        },
                    ],
                },
                {
                    labelName: 'Doubtful Questions',
                    categoryName: 'Doubtful',
                    id: 'Doubtful',
                    type: 'radio',
                    isRequired: true,
                    question: "What is your grandparent's name",
                    options: [
                        {
                            id: 'doubt_grandn1',
                            name: 'doubt_grandn',
                            value: 'Answered',
                            label: 'Answered',
                        },
                        {
                            id: 'doubt_grandn2',
                            name: 'doubt_grandn',
                            value: 'Not Answered',
                            label: 'Not Answered',
                        },
                    ],
                },
                {
                    labelName: 'Doubtful Questions',
                    categoryName: 'Doubtful',
                    id: 'Doubtful',
                    type: 'radio',
                    isRequired: true,
                    question: 'Please do a signature same as to your passport',
                    options: [
                        {
                            id: 'doubt_sign1',
                            name: 'doubt_sign',
                            value: 'Answered',
                            label: 'Answered',
                        },
                        {
                            id: 'doubt_sign2',
                            name: 'doubt_sign',
                            value: 'Not Answered',
                            label: 'Not Answered',
                        },
                    ],
                },
            ],
            subQuestionLabel: {
                label: 'Doubtful Questions',
                categoryName: 'Doubtful',
            },
        },
        {
            type: 'radio',
            labelName: 'Common Questions',
            categoryName: 'Common',
            isRequired: true,
            question: 'Could you please show me your surroundings so I can confirm that you are the only one in the room?',
            options: [
                {
                    id: 'surround_check0',
                    name: 'surround_check0',
                    value: 'Answered',
                    label: 'Yes',
                },
                {
                    id: 'surround_check1',
                    name: 'surround_check1',
                    value: 'Not Answered',
                    label: 'No',
                },
                {
                    id: 'surround_check2',
                    name: 'surround_check2',
                    value: 'Doubtful',
                    label: 'Doubtful',
                },
               
            ],
        },
        {
            type: 'radio',
            labelName: 'Common Questions',
            categoryName: 'Common',
            isRequired: true,
            question: 'I need to inform you that you are not allowed to record this session or any of the questions. Doing so may lead to your application being rejected by the University. Do you understand?',
            options: [
                {
                    id: 'rez_check0',
                    name: 'rez_check0',
                    value: 'Answered',
                    label: 'Yes',
                },
                {
                    id: 'rez_check1',
                    name: 'rez_check1',
                    value: 'Not Answered',
                    label: 'No',
                },
                {
                    id: 'rez_check3',
                    name: 'rez_check3',
                    value: 'Doubtful',
                    label: 'Doubtful',
                },
               
            ],
        },
        {
            labelName: 'Common Questions',
            categoryName: 'Common',
            type: 'radio',
            isRequired: true,
            question: 'This interview will take approximately 30 minutes. Are you feeling fit and well enough to proceed with the interview today?',
            options: [
                {
                    id: 'interview_ans1',
                    name: 'interview_ans',
                    value: 'Answered',
                    label: 'Answered',
                },
                {
                    id: 'interview_ans2',
                    name: 'interview_ans',
                    value: 'Not Answered',
                    label: 'Not Answered',
                },
            ],
        },
        {
            labelName: 'Common Questions',
            categoryName: 'Common',
            type: 'radio',
            isRequired: true,
            question: 'Can you hear me clearly and understand everything I’m saying?',
            options: [
                {
                    id: 'hear_me1',
                    name: 'interview_ans',
                    value: 'Answered',
                    label: 'Answered',
                },
                {
                    id: 'hear_me2',
                    name: 'interview_ans',
                    value: 'Not Answered',
                    label: 'Not Answered',
                },
            ],
        },

        {
            labelName: 'Common Questions',
            categoryName: 'Common',
            type: 'radio',
            isRequired: true,
            question: 'Can you please tell me your full name and date of birth?',
            options: [
                {
                    id: 'birth_ans1',
                    name: 'interview_ans',
                    value: 'Answered',
                    label: 'Answered',
                },
                {
                    id: 'birth_ans2',
                    name: 'interview_ans',
                    value: 'Not Answered',
                    label: 'Not Answered',
                },
            ],
        },

        {
            labelName: 'Common Questions',
            categoryName: 'Common',
            type: 'radio',
            isRequired: true,
            question: 'Which course have you applied to study at the University?',
            options: [
                {
                    id: 'appliedstudy_ans1',
                    name: 'appliedstudy_ans',
                    value: 'Answered',
                    label: 'Answered',
                },
                {
                    id: 'appliedstudy_ans2',
                    name: 'appliedstudy_ans',
                    value: 'Not Answered',
                    label: 'Not Answered',
                },
            ],
        },

        {
            labelName: 'Common Questions',
            categoryName: 'Common',
            type: 'radio',
            isRequired: true,
            question: 'Do you know what (BA, BSc, MA, MSc) stands for?',
            options: [
                {
                    id: 'coursestand_ans1',
                    name: 'appliedstudy_ans',
                    value: 'Answered',
                    label: 'Answered',
                },
                {
                    id: 'coursestand_ans2',
                    name: 'appliedstudy_ans',
                    value: 'Not Answered',
                    label: 'Not Answered',
                },
            ],
        },

        {
            labelName: 'Common Questions',
            categoryName: 'Common',
            type: 'radio',
            isRequired: true,
            question: 'I’ll be typing out both my questions and your answers, so I need you to speak slowly and clearly. If you are speaking too fast, I’ll ask you to stop, slow down, and repeat. Is that okay with you?',
            options: [
                {
                    id: 'type_qus1',
                    name: 'type_qus',
                    value: 'Answered',
                    label: 'Answered',
                },
                {
                    id: 'type_qus2',
                    name: 'type_qus',
                    value: 'Not Answered',
                    label: 'Not Answered',
                },
            ],
        },
    ];

    decisionQuestionArr: any = [
        {
            primary: {
                heading: 'Decision',
                label: 'Decision Questions',
                categoryName: 'Decision',
            },
            questions: [
                {
                    type: 'radio',
                    labelName: 'Decision Questions',
                    categoryName: 'Decision',
                    isRequired: true,
                    question: 'Have you understood all the questions?',
                    options: [
                        {
                            id: 'all_ans1',
                            name: 'all_ans',
                            value: 'Answered',
                            label: 'Answered',
                        },
                        {
                            id: 'all_ans2',
                            name: 'all_ans',
                            value: 'Not Answered',
                            label: 'Not Answered',
                        },
                    ],
                },
                {
                    labelName: 'Decision Questions',
                    categoryName: 'Decision',
                    type: 'radio',
                    isRequired: true,
                    question: 'Is there anything else you wish to add?',
                    options: [
                        {
                            id: 'anything_else1',
                            name: 'anything_else',
                            value: 'Answered',
                            label: 'Answered',
                        },
                        {
                            id: 'anything_else2',
                            name: 'anything_else',
                            value: 'Not Answered',
                            label: 'Not Answered',
                        },
                    ],
                },
                {
                    labelName: 'Decision Questions',
                    categoryName: 'Decision',
                    type: 'radio',
                    isRequired: true,
                    question:
                        'Are you happy with the conduct of the interview?',
                    options: [
                        {
                            id: 'int_happy1',
                            name: 'int_happy',
                            value: 'Answered',
                            label: 'Answered',
                        },
                        {
                            id: 'int_happy2',
                            name: 'int_happy',
                            value: 'Not Answered',
                            label: 'Not Answered',
                        },
                    ],
                },
            ],
        },
    ];

    interviewQuestions: any = [
        {
            primary: {
                heading: 'Interview Questions',
                label: 'Complusory Questions',
                categoryName: 'Complusory',
                riskFactor: Array.from({ length: 10 }, (_, index) => index + 1),
            },
            answersufficiency: {
                question: 'Student answered questions sufficiently?',
                categoryName: 'Complusory',
                labelName: 'Complusory Questions',
                type: 'options',
                options: [
                    {
                        value: 'YES',
                        label: 'Yes',
                    },
                    {
                        value: 'NO',
                        label: 'NO',
                    },
                ],
            },
            riskArea: {
                question:
                    'If Yes, address any risk areas scoring below 6 (for non-High Risk) or 7 (for High Risk) raised in interview.If No please comment below',
                answerType: 'textarea',
                labelName: 'Complusory Questions',
                categoryName: 'Complusory',
            },
            questionList: [
                {
                    labelName: 'Complusory Questions',
                    categoryName: 'Complusory',
                    question: 'UK Study Choice',
                    qOptions: [{
                        id:'How do you think studying in the UK could benefit you?',
                        value: 'How do you think studying in the UK could benefit you?',
                        label: 'How do you think studying in the UK could benefit you?',
                    },
                    {
                        id:'Why did you choose to study in the UK over other countries for you higher education?',
                        value: 'Why did you choose to study in the UK over other countries for you higher education?',
                        label: 'Why did you choose to study in the UK over other countries for you higher education?',
                    },
                    {
                        id:'What about the UK made you want to study there?',
                        value: 'What about the UK made you want to study there?',
                        label: 'What about the UK made you want to study there?',
                    }],
                    answerType: 'textarea',
                },
                {
                    labelName: 'Complusory Questions',
                    categoryName: 'Complusory',
                    question: 'Course Understanding',
                    qOptions: [{
                        id:'What course have you applied to study in the UK and why?',
                        value: 'What course have you applied to study in the UK and why?',
                        label: 'What course have you applied to study in the UK and why?',
                    },
                    {
                        id:'What do you like most about the course you have applied to study?',
                        value: 'What do you like most about the course you have applied to study?',
                        label: 'What do you like most about the course you have applied to study?',
                    },
                    {
                        id:'What skills do you think the course you have applied to will give you?',
                        value: 'What skills do you think the course you have applied to will give you?',
                        label: 'What skills do you think the course you have applied to will give you?',
                    },
                    {
                        id:'How have you been preparing yourself to succeed on the course?',
                        value: 'How have you been preparing yourself to succeed on the course?',
                        label: 'How have you been preparing yourself to succeed on the course?',
                    }],
                    answerType: 'textarea',
                },
                {
                    labelName: 'Complusory Questions',
                    categoryName: 'Complusory',
                    question: 'Trap Question',
                    qOptions: [{
                        id:'How do you handle stress and maintain a balance between your studies and personal life?',
                        value: 'How do you handle stress and maintain a balance between your studies and personal life?',
                        label: 'How do you handle stress and maintain a balance between your studies and personal life?',
                    },
                    {
                        id:'Apart from the Royal family, what do you know the UK for?',
                        value: 'Apart from the Royal family, what do you know the UK for?',
                        label: 'Apart from the Royal family, what do you know the UK for?',
                    },
                    {
                        id:'How would you describe yourself in one word and why? ',
                        value: 'How would you describe yourself in one word and why? ',
                        label: 'How would you describe yourself in one word and why? ',
                    }],
                    answerType: 'textarea',
                },
                {
                    labelName: 'Complusory Questions',
                    categoryName: 'Complusory',
                    question: 'University Choice Reasoning',
                    qOptions: [{
                        id:'What about Coventry University made you choose it as the institution to study in?',
                        value: 'What about Coventry University made you choose it as the institution to study in?',
                        label: 'What about Coventry University made you choose it as the institution to study in?',
                        },
                        {
                            id:'What other universities did you consider and why did you choose Coventry University over them?',
                            value: 'What other universities did you consider and why did you choose Coventry University over them?',
                            label: 'What other universities did you consider and why did you choose Coventry University over them?',
                        },
                        {
                            id:'How do you think studying at Coventry University will help you achieve your goals?',
                            value: 'How do you think studying at Coventry University will help you achieve your goals?',
                            label: 'How do you think studying at Coventry University will help you achieve your goals?',
                        }],
                    answerType: 'textarea',
                },
                {
                    labelName: 'Complusory Questions',
                    categoryName: 'Complusory',
                    question: 'Sector consideration',
                    qOptions: [{
                            id:'What research did you do before deciding what university to go to?',
                            value: 'what research did you do before deciding what university to go to?',
                            label: 'what research did you do before deciding what university to go to?',
                        },
                        {
                            id:'How did the reputation of the universities researched, impact your final decision?',
                            value: 'How did the reputation of the universities researched, impact your final decision?',
                            label: 'How did the reputation of the universities researched, impact your final decision?',
                        },
                        {
                            id:'How difficult was it for you in choosing the right university?',
                            value: 'How difficult was it for you in choosing the right university?',
                            label: 'How difficult was it for you in choosing the right university?',
                        }],
                    answerType: 'textarea',
                },
                {
                    labelName: 'Complusory Questions',
                    categoryName: 'Complusory',
                    question: 'Accommodation',
                    qOptions: [{
                        id:'Where will you be living in the UK while studying?',
                        value: 'Where will you be living in the UK while studying?',
                        label: 'Where will you be living in the UK while studying?',
                        },
                        {
                            id:'How do you think the distance between your accommodation and campus can affect your studies?',
                            value: 'How do you think the distance between your accommodation and campus can affect your studies?',
                            label: 'How do you think the distance between your accommodation and campus can affect your studies?',
                        },
                        {
                            id:'How did you choose your accommodation and how does it suit your academic and personal needs?',
                            value: 'How did you choose your accommodation and how does it suit your academic and personal needs?',
                            label: 'How did you choose your accommodation and how does it suit your academic and personal needs?',
                        },
                        {
                            id:'What is the distance between your accommodation and your university location?',
                            value: 'What is the distance between your accommodation and your university location?',
                            label: 'What is the distance between your accommodation and your university location?',
                        }],
                    answerType: 'textarea',
                },
                {
                    labelName: 'Complusory Questions',
                    categoryName: 'Complusory',
                    question: 'Trap Question',
                    qOptions: [{
                            id:'What do you like to do in your free time?',
                            value: 'What do you like to do in your free time?',
                            label: 'What do you like to do in your free time?',
                            },
                            {
                                id:'What does success mean to you?',
                                value: 'What does success mean to you?',
                                label: 'What does success mean to you?',
                            },
                            {
                                id:'If you were given a large sum of money to start a business, what would it be?',
                                value: 'If you were given a large sum of money to start a business, what would it be?',
                                label: 'If you were given a large sum of money to start a business, what would it be?',
                            }
                        ],
                    answerType: 'textarea',
                },
                {
                    labelName: 'Complusory Questions',
                    categoryName: 'Complusory',
                    question: 'Funding',
                    qOptions: [{
                        id:'How will you be paying for your tuition Fee and living costs while in the UK?',
                        value: 'How will you be paying for your tuition Fee and living costs while in the UK?',
                        label: 'How will you be paying for your tuition Fee and living costs while in the UK?',
                        },
                        {
                            id:'Based on the UKVI’s financial requirements for international students, what arrangements have you made to meet these throughout the duration of your studies in the UK?',
                            value: 'Based on the UKVI’s financial requirements for international students, what arrangements have you made to meet these throughout the duration of your studies in the UK?',
                            label: 'Based on the UKVI’s financial requirements for international students, what arrangements have you made to meet these throughout the duration of your studies in the UK?',
                        },
                        {
                            id:'Do you have enough funds to cover your expenses in the UK? How much?',
                            value: 'Do you have enough funds to cover your expenses in the UK? How much?',
                            label: 'Do you have enough funds to cover your expenses in the UK? How much?',
                        }],
                    answerType: 'textarea',
                },
                {
                    labelName: 'Complusory Questions',
                    categoryName: 'Complusory',
                    question: 'Academic History',
                    qOptions: [{
                        id:'What course did you last study before applying to the university in the UK?',
                        value: 'What course did you last study before applying to the university in the UK?',
                        label: 'What course did you last study before applying to the university in the UK?',
                        },
                        {
                            id:'What have you been doing up until now academically?',
                            value: 'What have you been doing up until now academically?',
                            label: 'What have you been doing up until now academically?',
                        },
                        {
                            id:'How do you think the way you studied in school previously can help you to study at a higher education level in the UK?',
                            value: 'How do you think the way you studied in school previously can help you to study at a higher education level in the UK?',
                            label: 'How do you think the way you studied in school previously can help you to study at a higher education level in the UK?',
                        }],
                    answerType: 'textarea',
                },
                {
                    labelName: 'Complusory Questions',
                    categoryName: 'Complusory',
                    question: 'Work Plans',
                    qOptions: [
                        {
                            id:'In addition to studying, do you also plan to gain work experience while in the UK?',
                            value: 'In addition to studying, do you also plan to gain work experience while in the UK?',
                            label: 'In addition to studying, do you also plan to gain work experience while in the UK?',
                        },
                        {
                            id:'Would you want to work part-time while studying? Why?',
                            value: 'Would you want to work part-time while studying? Why?',
                            label: 'Would you want to work part-time while studying? Why?',
                        },
                        {
                            id:'If you obtain a part-time work, would it be to support yourself financially to pay for tuition fee and living expenses?',
                            value: 'If you obtain a part-time work, would it be to support yourself financially to pay for tuition fee and living expenses?',
                            label: 'If you obtain a part-time work, would it be to support yourself financially to pay for tuition fee and living expenses?',
                        }
                    ],
                    answerType: 'textarea',
                },
                {
                    labelName: 'Complusory Questions',
                    categoryName: 'Complusory',
                    question: 'Post Study',
                    qOptions: [
                        {
                            id:'What do you plan to do when you finish studying at Coventry university?',
                            value: 'What do you plan to do when you finish studying at Coventry university?',
                            label: 'What do you plan to do when you finish studying at Coventry university?',
                        },
                        {
                            id:'What jobs can you do with the course you have applied to study?',
                            value: 'What jobs can you do with the course you have applied to study?',
                            label: 'What jobs can you do with the course you have applied to study?',
                        },
                        {
                            id:'Would you want to work with companies or start your own business after studies?',
                            value: 'Would you want to work with companies or start your own business after studies?',
                            label: 'Would you want to work with companies or start your own business after studies?',
                        },
                        {
                            id:'Which countries and companies would you like to work in and why?',
                            value: 'Which countries and companies would you like to work in and why?',
                            label: 'Which countries and companies would you like to work in and why?',
                        }
                    ],
                    answerType: 'textarea',
                },
                {
                    labelName: 'Complusory Questions',
                    categoryName: 'Complusory',
                    question: 'Career and Professional Development',
                    qOptions: [
                        {
                            id:'How do you think studying in the UK and at Coventry University will help you with your future plans?',
                            value: 'How do you think studying in the UK and at Coventry University will help you with your future plans?',
                            label: 'How do you think studying in the UK and at Coventry University will help you with your future plans?',
                        },
                        {
                            id:'Do you plan to do extra courses different from your degree to develop yourself professionally?',
                            value: 'Do you plan to do extra courses different from your degree to develop yourself professionally?',
                            label: 'Do you plan to do extra courses different from your degree to develop yourself professionally?',
                        },
                        {
                            id:'How is the Job market in your home country for graduates currently?',
                            value: 'How is the Job market in your home country for graduates currently?',
                            label: 'How is the Job market in your home country for graduates currently?',
                        }
                    ],
                    answerType: 'textarea',
                },
                {
                    labelName: 'Complusory Questions',
                    categoryName: 'Complusory',
                    question: "What Visa Application Centre would you be applying from?\n • Record applicant’s response and include on the transcript",
                    qOptions: [],
                    answerType: 'textarea',
                },
                {
                    labelName: 'Complusory Questions',
                    categoryName: 'Complusory',
                    question:'Visa Refusal:• Have you ever received a visa refusal? If so, please state the name of the country, the year, and explain why you have been refused.',
                    qOptions: [],
                    answerType: 'textarea',
                },
                {
                    labelName: 'Complusory Questions',
                    categoryName: 'Complusory',
                    question:
                        'What region are you from? (India only)Gujarat, Telangana - 2Punjab, Uttar Pradesh, Andra Pradesh, Haryana, Uttarakhand - 1',
                    qOptions: [],
                    answerType: 'textarea',
                },
                {
                    labelName: 'Complusory Questions',
                    categoryName: 'Complusory',
                    question:
                        'Dependants:• Will you be bringing dependants? Dependants are usually members of your family such as a spouse (wife/husband), partner or child who is financially dependent on you.',
                    qOptions: [],
                    answerType: 'textarea',
                },
                {
                    labelName: 'Complusory Questions',
                    categoryName: 'Complusory',
                    question: "Rate applicant's English ability",
                    qOptions: [],
                    answerType: 'textarea',
                },
                
            ],
        },
    ];

    user_details: any

    constructor(
        private _fb: FormBuilder,
        private _route: ActivatedRoute,
        private _loaderService: LoaderService,
        private _toasterService: ToasterService,
        private navigationService: NavigationService,
        private _formService: FormMasterService,
        private _universityService: UniversityService,
        private _authenticationService: AuthenticationService
    ) {}

    ngOnInit(): void {
        this.user_details = this._authenticationService.getLoginUserDetails();
        this._universityService.submitForms.subscribe((res) => {
            if (res) this.onSubmit();
        });

        this.interviewForm = this._fb.group({
            radioQuestions: this._fb.array([]),
            decisionQuestions: this._fb.array([]),
            compulsoryQuestions: this._fb.array([]),
        });

        this.initRadioQuestions();
        this.initCompulsoryQuestions();

        this.initiateOptionsForm();
        this.getUniversity();

        this.option_id = this._route.snapshot.paramMap.get('id');
        // if (this.option_id) {
        //     this.getOptionById();
        // }
    }

    goToList() {
        let url = `${urlRoutes.mainLayout}/${urlRoutes.form_master}`;
        this.navigationService.routeToPath(url);
    }

    initiateOptionsForm() {
        this.option_form = this._fb.group({
            name: ['', Validators.required],
            sortOrder: ['', Validators.required],
            // options: ['', Validators.required],
            options: this._fb.array([]),
            status: [true, Validators.required],
            // inputType: ['', Validators.required],
            // indivisualOption: [''],
            universityId: ['', Validators.required],
            // invoiceFinalTemplate: ['']
        });
    }

    get formArr() {
        return this.option_form.get('options') as FormArray;
    }

    initRows(data?: any) {
        return this._fb.group({
            id: [random4DigitId().toString()],
            question: ['', Validators.required],
            answer: ['', Validators.required],
            risk: [''],
            category: [''],
        });
    }

    addItem() {
        this.formArr.push(this.initRows());
    }

    deleteItem(index: number) {
        this.formArr.removeAt(index);
    }

    patchFormValues(data: any) {
        this.option_form.patchValue({
            name: data.name,
            sortOrder: data.sortOrder,
            universityId: data.universityId,
            // inputtype: data?.inputtype,
            // indivisualOption: data?.inputType === this.option_input_types.text ? (data.options[0]?.name ?? '') : '',
            // universityCountry: data?.inputType === this.option_input_types.text ? (data.options[0]?.universityCountry ?? []) : '',
            // status: (data.status === 'Enabled' || data.status === 'true') ? true : false
        });
        if (data.options.length > 0) {
            data.options.forEach((ele) => {
                const options = this.initRows();
                options.patchValue({
                    id: ele.id ?? random4DigitId().toString(),
                    question: ele.question,
                    answer: ele.answer,
                    risk: ele.risk,
                    category: ele?.category,
                });
                (this.option_form.get('options') as FormArray).push(options);
            });
        }
    }

    // getOptionById() {
    //     this._loaderService.showLoader();
    //     this._formService
    //         .getOptionById(this.option_id)
    //         .pipe(takeUntil(this._unsubscribeAll))
    //         .subscribe(
    //             (res) => {
    //                 if (res) {
    //                     let option_details = res?.data;
    //                     this.options_values = option_details?.options;
    //                     this.patchFormValues(option_details);
    //                     this._loaderService.hideLoader();
    //                 }
    //             },
    //             (err) => {
    //                 this._loaderService.hideLoader();
    //             }
    //         );
    // }

    getUniversity() {
        this._loaderService.showLoader();
        this._universityService
            .getUniversity(
                this.university_pagination,
                '',
                '',
                this.search_university
            )
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(
                (res) => {
                    let university = res?.data;
                    this.university = university?.data?.map((v) => {
                        return { id: v.id, name: v.name };
                    });
                    this.total_university_count = university?.data?.total;
                    this._loaderService.hideLoader();
                },
                (err) => {
                    this._loaderService.hideLoader();
                }
            );
    }

    getNextUniversity() {
        this.university_pagination.skip = 0;
        this.university_pagination.limit += 100;
        this.university_offset += this.university_pagination.limit;
        this.getUniversity();
    }

    filterUniversity() {
        this.university_filter.valueChanges
            .pipe(
                debounceTime(this.search_entiry.debounce_time),
                distinctUntilChanged(),
                takeUntil(this._unsubscribeAll)
            )
            .subscribe((res: string) => {
                this.search_university = res;
                this.getUniversity();
            });
    }

    uniCountryChange(event: MatSelectChange) {
        // let find_name = this.university_countries_lists.find(element => element.id === event.value)?.name;
        // this.option_form.get('universityCountryName').setValue(find_name);
    }

    inputTypeChange(event: MatSelectChange) {
        this.option_form.get('options').reset();
        if (event.value === this.option_input_types.text) {
            this.option_form
                .get('universityCountry')
                .setValidators([Validators.required]);
            this.option_form.get('universityCountry').updateValueAndValidity();
        } else if (event.value === this.option_input_types.dropdown) {
            this.option_form.get('universityCountry').clearValidators();
            this.option_form.get('universityCountry').updateValueAndValidity();
        } else {
        }
    }

    submit() {
        // if (this.option_form.invalid || !this.is_option_values_valid) {
        //   return;
        // }
        delete this.option_form.value.indivisualOption;
        delete this.option_form.value.universityCountry;
        if (this.option_id) {
            this.updateOption();
        } else {
            this.addOption();
        }
    }

    onChanged(event) {
        if (event) {
            this.option_form.get('options').patchValue(event.option_values);
            this.is_option_values_valid = event.is_valid;
        } else {
            this.is_option_values_valid = false;
        }
    }

    addOption() {
        this._loaderService.showLoader();
        this._formService
            .createOptions(this.option_form.value)
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(
                (result) => {
                    this._toasterService.showSuccess(
                        'SUCCESS',
                        'Option added successfully'
                    );
                    this._loaderService.hideLoader();
                    this.goToList();
                },
                (err) => {
                    this._loaderService.hideLoader();
                }
            );
    }

    updateOption() {
        this._loaderService.showLoader();
        this._formService
            .editOptions(this.option_id, this.option_form.value)
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(
                (result) => {
                    this._toasterService.showSuccess(
                        'SUCCESS',
                        'Option updated successfully'
                    );
                    this._loaderService.hideLoader();
                    this.goToList();
                },
                (err) => {
                    this._loaderService.hideLoader();
                }
            );
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    initRadioQuestions() {
        const control = this.interviewForm.get('radioQuestions') as FormArray;
        const decisionControl = this.interviewForm.get(
            'decisionQuestions'
        ) as FormArray;
        this.radioQuestionArr.forEach((q, index) => {
            const group = this._fb.group({
                question: [q.question],
                answer: [
                    (this.questions &&
                        this.questions?.radioData[index]?.answer) ||
                        '',
                    Validators.required,
                ],
                subQuestions: this._fb.array([]),
            });
            control.push(group);
            if (
                this.questions?.radioData[index]?.subQuestions &&
                this.questions?.radioData[index]?.subQuestions.length > 0
            ) {
                this.onChanges(
                    group,
                    index,
                    this.questions?.radioData[index]?.subQuestions
                );
            }
        });
        this.decisionQuestionArr[0]?.questions.forEach((q, index) => {
            const group = this._fb.group({
                question: [q.question],
                answer: [
                    this.questions?.decisionRadioData[index].answer || '',
                    Validators.required,
                ],
            });
            decisionControl.push(group);
        });
    }

    onChanges(control: any, index: number = 0, subQuestions: any = {}): void {
        this.updateSubQuestions(control, index, subQuestions);
    }

    updateSubQuestions(
        control: FormGroup,
        index: number = 0,
        subQuestions: any = {}
    ) {
        const question = this.radioQuestionArr[index];
        const answer = control.get('answer').value;

        if (question.subQuestions) {
            const subControl = control.get('subQuestions') as FormArray;
            subControl.clear();

            if (question.options) {
                question.subQuestions
                    .filter((item) => item.id === answer)
                    .forEach((subQ) => {
                        const subGroup = this._fb.group({
                            question: [subQ.question],
                            answer: [subQuestions[index]?.answer || ''],
                        });
                        subControl.push(subGroup);
                    });
            }
        }
    }

    initCompulsoryQuestions() {
        const control = <FormArray>(
            this.interviewForm.get('compulsoryQuestions')
        );
        this.interviewQuestions.forEach((q) => {
            const group = this._fb.group({
                answersufficiency: this._fb.group({
                    question: [q.answersufficiency.question],
                    answer: ['', Validators.required],
                    riskArea: this._fb.group({
                        question: [q.riskArea.question],
                        answer: [''],
                    }),
                }),
                // riskArea: this._fb.group({
                //     question: [q.riskArea.question],
                //     answer: [''],
                // }),
                questionList: this._fb.array(
                    q.questionList.map((item, index) =>
                        this._fb.group({
                            question: [item.question],
                            answerRadio:[],
                            answer: [
                                this.questions?.complusoryQuestionList[index]
                                    ?.answer || '',
                            ],
                            riskFactor: [
                                this.questions?.complusoryQuestionList[index]
                                    ?.risk || '',
                            ],
                        })
                    )
                ),
            });
            control.push(group);
        });
        // this.interviewForm.valueChanges.subscribe((res) => {
        //     console.log(res);
        //     console.log(this.interviewForm?.value);
        // });
    }

    onSubmit() {
        console.log(this.interviewForm?.value);
        const radioData = this.interviewForm?.value?.radioQuestions.map(
            (element, index) => {
                return {
                    labelName: this.radioQuestionArr[index]?.labelName,
                    question: this.radioQuestionArr[index]?.question,
                    answer: element?.answer,
                    answerType: this.radioQuestionArr[index]?.type,
                    asnwerValues: this.radioQuestionArr[index]?.options.map(
                        (item) => {
                            return {
                                id: item?.id,
                                values: item?.label,
                            };
                        }
                    ),
                    categoryName: this.radioQuestionArr[index]?.categoryName,
                    optionalFields: [],
                    subQuestions: this.radioQuestionArr[
                        index
                    ]?.subQuestions?.map((item, subIndex) => {
                        return {
                            labelName:
                                this.radioQuestionArr[index]?.subQuestionLabel
                                    ?.label,
                            questions: item?.question,
                            categoryName: item?.categoryName,
                            answer: element.subQuestions[subIndex]?.answer,
                            answerType: item?.type,
                            answerValues: item.options.map((item) => {
                                return {
                                    id: item?.id,
                                    values: item?.label,
                                };
                            }),
                            optionalFields: [],
                        };
                    }),
                };
            }
        );

        const complusoryQuestionList =
            this.interviewForm?.value?.compulsoryQuestions[0].questionList.map(
                (element, index) => {
                    return {
                        labelName:
                            this.interviewQuestions[0]?.questionList[index]
                                ?.labelName,
                        question:
                            this.interviewQuestions[0]?.questionList[index]
                                ?.question,
                        optionQuestion: element?.answerRadio,
                        answer: element?.answer,
                        risk: element?.riskFactor,
                        answerType:
                            this.interviewQuestions[0]?.questionList[index]
                                ?.answerType,
                        answerValues: [],
                        categoryName:
                            this.interviewQuestions[0]?.questionList[index]
                                ?.categoryName,
                        optionalFields: [],
                        subQuestions: [],
                    };
                }
            );

        const answersufficiency: any = {
            labelName: this.interviewQuestions[0]?.answersufficiency?.labelName,
            question: this.interviewQuestions[0]?.answersufficiency?.question,
            answer: this.interviewForm?.value?.compulsoryQuestions[0]
                .answersufficiency?.answer,
            answerType: this.interviewQuestions[0]?.answersufficiency?.type,
            answerValues:
                this.interviewQuestions[0]?.answersufficiency.options.map(
                    (item, index) => {
                        return {
                            id: index,
                            values: item?.label,
                        };
                    }
                ),
            categoryName:
                this.interviewQuestions[0]?.answersufficiency?.categoryName,
            optionalFields: [],
            subQuestions: [],
        };

        const riskArea = {
            labelName: this.interviewQuestions[0]?.riskArea?.labelName,
            question: this.interviewQuestions[0]?.riskArea?.question,
            answer: this.interviewForm?.value?.compulsoryQuestions[0]
                .answersufficiency.riskArea?.answer,
            answerType: this.interviewQuestions[0]?.riskArea?.answerType,
            answerValues: [],
            categoryName: this.interviewQuestions[0]?.riskArea?.categoryName,
            optionalFields: [],
            subQuestions: [],
        };

        const decisionRadioData =
            this.interviewForm?.value?.decisionQuestions.map(
                (element, index) => {
                    return {
                        labelName:
                            this.decisionQuestionArr[0]?.questions[index]
                                ?.labelName,
                        question:
                            this.decisionQuestionArr[0]?.questions[index]
                                ?.question,
                        answer: element?.answer,
                        answerType:
                            this.decisionQuestionArr[0]?.questions[index]?.type,
                        asnwerValues: this.decisionQuestionArr[0]?.questions[
                            index
                        ].options.map((item) => {
                            return {
                                id: item?.id,
                                values: item?.label,
                            };
                        }),
                        categoryName:
                            this.decisionQuestionArr[0]?.questions[index]
                                .categoryName,
                        optionalFields: [],
                        subQuestions: [],
                    };
                }
            );

        // const questions = [
        //     ...radioData,
        //     ...complusoryQuestionList,
        //     answersufficiency,
        //     riskArea,
        //     ...decisionRadioData,
        // ];

        const questions = {
            radioData,
            complusoryQuestionList,
            answersufficiency,
            riskArea,
            decisionRadioData,
        };
        this.formSubmit.emit({
            questions,
        });
    }
}
